<template>
  <div class="container-page">
    <p class="title-inner">Инфляция</p>
    <div class="mb-16">
      <ButtonComponent
        v-permission="permissions.import"
        mod="gradient-bg"
        buttonType="button"
        :disabled="importInProgress"
        @click="importExcel()"
      >
        {{ !importInProgress ? 'Загрузить из Excel' : 'Загрузка...' }}
      </ButtonComponent>
    </div>
    <div class="mb-4">
      <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
    </div>
    <div v-if="isAccessAllowed">
      <div class="table-container mb-16 js-table-arrow">
        <table class="stockTable">
          <thead>
            <tr>
              <th>Период</th>
              <th>Страна</th>
              <th>Значение</th>
            </tr>
            <tr>
              <th class="filter">
                <FilterInput
                  type="month"
                  v-model="filter.periodFrom"
                  placeholder="от"
                  v-on:valueChangedDebounced="changeFilter()"
                />
                <FilterInput
                  type="month"
                  v-model="filter.periodTo"
                  placeholder="до"
                  v-on:valueChangedDebounced="changeFilter()"
                />
              </th>
              <th class="filter">
                <FilterInput
                  type="select2"
                  :select2Options="countries"
                  :select2Settings="select2Settings"
                  v-model="filter.countryId"
                  placeholder="(Все)"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <div class="range">
                  <FilterInput
                    type="number"
                    v-model="filter.valueFrom"
                    class="mr-2"
                    placeholder="от"
                    v-on:valueChangedDebounced="changeFilter()"
                  />
                  <FilterInput
                    type="number"
                    v-model="filter.valueTo"
                    placeholder="до"
                    v-on:valueChangedDebounced="changeFilter()"
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody v-if="page.items?.length && !isLoading">
            <tr v-for="item in page.items" :key="item.id">
              <td>{{ $momentFormat(item.period, 'MM.YYYY') }}</td>
              <td>{{ item.country?.nameFull || item.country?.name }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td class="text-center" colspan="5">Загрузка...</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="5">Нет данных.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination
          :pageCount="page.pagesTotal"
          :currentPage="page.pageNumber"
          @change="onPageChange($event, false)"
          @more="onPageChange($event, true)"
        />
      </div>
    </div>
    <section>
      <ModalComponent v-model="importModal" title="Импорт файла" @close="closeModal">
        <ImportModal @doimport="doImport" @close="closeModal" />
      </ModalComponent>
    </section>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import ImportModal from '@/components/modals/ImportModal.vue';

  import FilterInput from '../../../common/components/FilterInput.vue';
  import ModalComponent from '../../../components/modals/ModalComponent.vue';
  import Api from '../api/index';

  const PERMISSIONS = {
    view: Constants.Permissions.InflationView,
    import: Constants.Permissions.InflationImport,
  };

  export default {
    name: 'InflationRate',
    components: { ImportModal, ModalComponent, ButtonComponent, FilterInput, DefaultFilter },
    mixins: [security],
    data() {
      return {
        route: 'inflation',
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },

        select2Settings: Constants.select2Settings,
        countries: [],

        filter: {
          periodFrom: null,
          periodTo: null,
          countryId: null,
          valueFrom: null,
          valueTo: null,
        },
        importInProgress: false,
        importModal: false,
        isLoading: false,
      };
    },
    computed: {
      permissions: () => PERMISSIONS,
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view).then((isAllowed) => {
        if (!isAllowed) return;

        loadFilter(this.$options.name).then((response) => {
          let filter = response;
          if (filter) {
            this.filter = filter;
          }
          this.loadPage();
          this.loadDictionaries();
        });
      });
    },
    methods: {
      loadPage(append) {
        this.isLoading = !append;
        const params = Object.assign(this.filter, this.request);
        Api.search(this.route, params)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      loadDictionaries() {
        Utils.searchNsi('countrylistwithdata', {})
          .then((response) => {
            this.countries = response.data.map((x) => {
              return { text: x.name, id: x.id };
            });
          })
          .catch((error) => {
            console.error(error?.response?.data);
          });
      },
      importExcel() {
        this.importModal = true;
      },
      doImport(file) {
        this.closeModal();
        this.importInProgress = true;
        Api.downloadFile(this.route, file)
          .then(() => {
            Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
            this.loadPage();
            this.importInProgress = false;
          })
          .catch((error) => {
            console.log(error?.response?.data);
            Constants.alert.fire('Импорт', 'Ошибка при импорте данных.', 'error');
            this.importInProgress = false;
          });
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      closeModal() {
        this.importModal = false;
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
